import { fetchCountriesFromPairs } from '@/services/countries';
import type { Country } from '@/types/country';
import { useEffect, useState } from 'react';

let cache: Country[] | null = null;

export function useCountries() {
  const [countries, setCountries] = useState<Country[]>(cache ?? []);
  const [loading, setLoading] = useState(!cache);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (cache) return;

    setLoading(true);
    fetchCountriesFromPairs()
      .then(list => {
        cache = list;
        setCountries(list);
      })
      .catch(e => setError(e?.message ?? 'Failed to load countries'))
      .finally(() => setLoading(false));
  }, []);

  return { countries, loading, error };
}
